export default class {

    constructor ($translate, lodash, CommonService, ClassifierResource,
                 PrivilegeService, SiteService, ModalService,
                 CLASSIFIER_ENUM, COURSE_EXPIRATION_ENUM, COURSE_SITE_ACCESS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.CommonService = CommonService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.ModalService = ModalService;
        this.ClassifierResource = ClassifierResource;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_EXPIRATION_ENUM = COURSE_EXPIRATION_ENUM;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
    }

    loadFieldTags (value) {
        return this.ClassifierResource.query({ type: this.CLASSIFIER_ENUM.KEYS.FIELD, value, pageSize: 0 })
            .$promise
            .then((result) => {
                return result.map((val) => ({ text: val.value, id: val.id }));
            });
    }

    canManageCourse (course) {
        if (this.PrivilegeService.isCompanyAdmin() || !course.id) {
            return true;
        }

        const isAllSites = course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
        if (isAllSites) {
            return this.PrivilegeService.isSiteAccessForAllUsers() && this.PrivilegeService.canManageCourses();
        }

        if (!course.sites) {
            return false;
        }

        const privileges = this.PrivilegeService.getCourseManagePrivileges();

        if (this.PrivilegeService.isSiteAccessForAllUsers()) {
            // if user has manage privilege in any site then allow user to manage course data
            return course.sites.filter(site => this.SiteService.hasPrivilegeInSite(site.id, privileges)).length > 0;
        }

        // if user has manage privilege and there is only one access site
        return course.sites.length === 1 && course.sites.filter(site => this.SiteService.hasPrivilegeInSite(site.id, privileges)).length > 0;
    }

    getExpirationOptions () {
        return [
            {
                value: `'${this.COURSE_EXPIRATION_ENUM.KEYS.NEVER}'`,
                label: this.$translate.instant('course.expiration.Never')
            },
            {
                value: 12, label: this.$translate.instant(
                '{n, plural, one {course.expiration.# year} other {course.expiration.# years}}', { n: 1 })
            },
            {
                value: 24,
                label: this.$translate.instant(
                    '{n, plural, one {course.expiration.# year} other {course.expiration.# years}}', { n: 2 })
            },
            {
                value: 36,
                label: this.$translate.instant(
                    '{n, plural, one {course.expiration.# year} other {course.expiration.# years}}', { n: 3 })
            },
            {
                value: 60,
                label: this.$translate.instant(
                    '{n, plural, one {course.expiration.# year} other {course.expiration.# years}}', { n: 5 })
            },
            {
                value: `'${this.COURSE_EXPIRATION_ENUM.KEYS.OTHER}'`,
                label: this.$translate.instant('course.expiration.Other')
            }
        ];
    }

    getExpirationForModel (radioButtonValue, customExpiration) {
        let value = radioButtonValue;
        if (radioButtonValue === this.COURSE_EXPIRATION_ENUM.KEYS.OTHER) {
            value = customExpiration.months;
            if (customExpiration.years) {
                value = value + customExpiration.years * 12;
            }
        }
        else if (radioButtonValue === this.COURSE_EXPIRATION_ENUM.KEYS.NEVER) {
            value = 0; // will be converted to NULL on api level
        }
        return value;
    }

    nestCompositeModels (course) {
        this.CommonService.nestModel(course, 'courseTrainingI18ns', 'courseTrainings', 'trainingId', 'id', 'language');
        this.CommonService.nestModel(course, 'courseTrainingForms', 'courseTrainings', 'trainingId', 'id');
        this.CommonService.nestModel(course, 'courseTrainings', 'courseVersions', 'courseVersionId', 'id');
    }

    getImageUrl (course, thumbnailDir) {
        let baseUrl = `${SEED_CORE.ENV.API_URL}courses/${course.companyId}/${course.id}`;
        if (thumbnailDir) {
            baseUrl = `${baseUrl}/thumbnails/${thumbnailDir}`;
        }
        return `${baseUrl}/${course.imageFilename}`;
    }


    getFieldNames (course, fieldsWithAcitveI18n) {
        if (!course.fields || !fieldsWithAcitveI18n) {
            return '';
        }

        return course.fields.map((field) => {
            return this.lodash.find(fieldsWithAcitveI18n, fieldI18n => fieldI18n.id === field.id).activeI18n.value;
        }).join(', ');
    }

    openHistoricParticipationModal (course) {
        return this.ModalService.open({
            size: 'xlarge',
            template: `
                <modals-courses-historic-occurrence
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    course="vm.course"
                />`,
            controller ($uibModalInstance) {
                this.course = course;
                this.$uibModalInstance = $uibModalInstance;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/index.js